import actions from "./actions";

const initState = {
    planPriceConfigList: [],
    planPriceConfigLoading: false,
    planPriceConfigError: null,

    updatePlanPriceConfigMessage: null,
    updatePlanPriceConfigLoading: false,
    updatePlanPriceConfigError: null,

    
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_PLAN_PRICE_CONFIG_LIST:
            return {
                ...state,
                planPriceConfigList: [],
                planPriceConfigLoading: true,
                planPriceConfigError: null,
            };

        case actions.GET_PLAN_PRICE_CONFIG_LIST_SUCCESS:
            return {
                ...state,
                planPriceConfigLoading: false,
                planPriceConfigError: null,
                planPriceConfigList: action.payload.data,
            };

        case actions.GET_PLAN_PRICE_CONFIG_LIST_FAILED:
            return {
                ...state,
                planPriceConfigLoading: false,
                planPriceConfigError: action.error,
            };

        case actions.UPDATE_PLAN_PRICE_CONFIG:
            return {
                ...state,
                updatePlanPriceConfigMessage: null,
                updatePlanPriceConfigLoading: true,
                updatePlanPriceConfigError: null,
            };

        case actions.UPDATE_SIMSwap_PRICE_CONFIG:
            return {
                ...state,
                updatePlanPriceConfigMessage: null,
                updatePlanPriceConfigLoading: true,
                updatePlanPriceConfigError: null,
            };

        case actions.UPDATE_PLAN_PRICE_CONFIG_SUCCESS:
            return {
                ...state,
                updatePlanPriceConfigLoading: false,
                updatePlanPriceConfigError: null,
                updatePlanPriceConfigMessage: action.payload.message,
            };

        case actions.UPDATE_PLAN_PRICE_CONFIG_FAILED:
            return {
                ...state,
                updatePlanPriceConfigLoading: false,
                updatePlanPriceConfigError: action.error,
                updatePlanPriceConfigMessage:null
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                planPriceConfigError: null,
                updatePlanPriceConfigMessage: null,
                updatePlanPriceConfigError: null,
            };

        default:
            return state;
    }
}